var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rc-label-design"},[_c('label',{staticClass:"item-name"},[_vm._v(_vm._s(_vm.component.name))]),_vm._v(" "),_c('div',{staticClass:"component-content"},[_c('div',{ref:"editor",staticClass:"editor"}),_vm._v(" "),_c('div',{staticClass:"model"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54d9ab10","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/components/label/rc-label.vue
// module id = null
// module chunks = 